import { StartingPageComponent } from './starting-page.component';

export const containers = [StartingPageComponent];

export * from './starting-page.component';
